import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import Page from '@/views/Page';
import error404 from '@/assets/images/error-img.png';
import { useTranslation } from 'react-i18next';

const Page404 = () => {
  const { t } = useTranslation();

  return (
    <Page metaTitle="Error 404">
      <div className="bg-light">
        <div className="authentication-bg min-vh-100 py-5 py-lg-0">
          <div className="bg-overlay bg-light"></div>
          <Container>
            <Row>
              <Col lg={12}>
                <Row>
                  <div className="col-lg-12">
                    <div className="text-center mb-5">
                      <h1 className="error-title">
                        {' '}
                        <span className="blink-infinite">404</span>
                      </h1>
                      <h4 className="text-uppercase">{t('error404.title')}</h4>
                      <div className="mt-5 text-center">
                        <Link
                          className="btn btn-primary waves-effect waves-light"
                          to="/"
                        >
                          {t('error404.btn_cta')}
                        </Link>
                      </div>
                    </div>
                  </div>
                </Row>
                <Row className="justify-content-center">
                  <div className="col-md-8 col-xl-7">
                    <div className="mt-2">
                      <img src={error404} alt="" className="img-fluid" />
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </Page>
  );
};

export default Page404;
